export type AppLanguage = {
  code: string;
  label: string;
};

export const LANGUAGES: AppLanguage[] = [
  { code: 'pl', label: 'PL' },
  { code: 'en', label: 'EN' },
  { code: 'uk', label: 'UK' },
];